/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GenerateEventSubmissionTokenResponse
 */
export interface GenerateEventSubmissionTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof GenerateEventSubmissionTokenResponse
     */
    oAuthToken: string;
}

/**
 * Check if a given object implements the GenerateEventSubmissionTokenResponse interface.
 */
export function instanceOfGenerateEventSubmissionTokenResponse(value: object): value is GenerateEventSubmissionTokenResponse {
    if (!('oAuthToken' in value) || value['oAuthToken'] === undefined) return false;
    return true;
}

export function GenerateEventSubmissionTokenResponseFromJSON(json: any): GenerateEventSubmissionTokenResponse {
    return GenerateEventSubmissionTokenResponseFromJSONTyped(json, false);
}

export function GenerateEventSubmissionTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenerateEventSubmissionTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'oAuthToken': json['oAuthToken'],
    };
}

export function GenerateEventSubmissionTokenResponseToJSON(json: any): GenerateEventSubmissionTokenResponse {
    return GenerateEventSubmissionTokenResponseToJSONTyped(json, false);
}

export function GenerateEventSubmissionTokenResponseToJSONTyped(value?: GenerateEventSubmissionTokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oAuthToken': value['oAuthToken'],
    };
}

